/**
 * Operations we want to apply for all analytics events should be added as middleware
 * to allow a standard `window.analytics.track` call to handle custom logic such as adding
 * additional ids, enhancing events with special properties, filtering out sensitive data, etc
 * */
// Order matters here
var middleware = [];
export function applyMiddleware() {
    var _a;
    middleware.forEach((_a = window.analytics) === null || _a === void 0 ? void 0 : _a.addSourceMiddleware);
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWlkZGxld2FyZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy91dGlscy9taWRkbGV3YXJlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVBOzs7O0tBSUs7QUFFTCxxQkFBcUI7QUFDckIsSUFBTSxVQUFVLEdBQXlCLEVBQUUsQ0FBQztBQUU1QyxNQUFNLFVBQVUsZUFBZTs7SUFDN0IsVUFBVSxDQUFDLE9BQU8sQ0FBQyxNQUFBLE1BQU0sQ0FBQyxTQUFTLDBDQUFFLG1CQUFtQixDQUFDLENBQUM7QUFDNUQsQ0FBQyJ9